import type { FaireProductEntity } from "../../entity_types/product";

export const p_9sq55263jg: FaireProductEntity = {
  token: "p_9sq55263jg",
  type: "product",
  name: "The Rio Washer Hoops- Silver",
  brandToken: "b_2p3pcs27",
  brandName: "Luv AJ",
  imageUrl:
    "https://cdn.faire.com/fastly/a83bcc5649b05cfe85c129ac57e5a1d9d7156e74321d077e04871001d610e101.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d94cb700ad1bb583302b8effa3abb59621a761ba276ca18b692f0e0174b4f891.jpeg",
    "https://cdn.faire.com/fastly/6de47c50a1ef87508f8835e34115711c8e3d34aa2c7281170caf7aa7d100ed5d.jpeg",
    "https://cdn.faire.com/fastly/11103376e8a177631ab8e41409f2378de4f5cc7dd076cd1a454b0c9bec1b053b.jpeg",
    "https://cdn.faire.com/fastly/20b3b51160dc85d6676ae0af651acbfcdde4025e407bb834fe0517ea11784ba5.jpeg",
  ],
  priceDollars: 38,
  description:
    "Details\n\n * Pair of interlock hoops featuring a real Rose Quartz stone washer bead\n\n * Rose quartz washer bead is removable\n\n * Hoop is 19mm x 4mm\n\n * Stone washer is 16mm x 7mm \n * Each pair weighs 0.50 grams \n * Please note- the rose quartz stone may have slight variations due to its handmade nature \n * 1 year warranty \n * All LuvAj.com orders are sent in Luv Aj branded gift boxes or packaging \nMaterials\n\n * Plating is waterproof and tarnish free \n * Made from plated brass and natural stone \n * 14K plated brass and Rhodium plated silver with E-Coating \n * Plating details: 0.3 microns + e-coating for long lasting durability \n * Plated high polish 14K Gold or Rhodium for maximum shine \n\n * Posts are made from surgical steel so they are very hypo-allergenic for sensitive ears \n * Earrings are 100% nickel-free and cadmium-free \n\n",
  tags: [],
  msrpDollars: 95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:50.901Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
